import patient from '../stores/patient'

export default function getStoryPatientName() {
  switch (patient.fields.ethnicity) {
    case 'HISPANIC_LATINO':
      return patient.fields.gender === 'MALE' ? 'Carlos' : 'Maria'
    case 'EAST_ASIAN':
      return patient.fields.gender === 'MALE' ? 'John' : 'Helen'
    case 'SOUTH_ASIAN':
      return patient.fields.gender === 'MALE' ? 'Raj' : 'Jaya'
    case 'BLACK_AFRICAN_AMERICAN':
      return patient.fields.gender === 'MALE' ? 'Charles' : 'Norma'
    default:
      return patient.fields.gender === 'MALE' ? 'Bob' : 'Linda'
  }
}



// WEBPACK FOOTER //
// ./src/utils/getStoryPatientName.js